module.exports = __webpack_public_path__ + "static/media/Orientation2.ed255cc8.jpeg";